<template>
    <div class="header">
        <el-header>
            <div class="tContent">
                <div class="h_l">
                    <div class="h_logo">
                        <img :src="logo ? logo : bdLogo" alt="logo">
                    </div>
                    <div class="h_m">
                        <div class="menu">
                            <el-menu class="el-menu-demo" mode="horizontal" 
                                background-color="transparent" text-color="#fff" style="border: none;" router>
                                <el-menu-item index="/">首页</el-menu-item>
                                <el-submenu index="2">
                                    <template slot="title">新闻</template>
                                    <el-menu-item v-for="item in newList" :key="item.id"
                                        :index="'news?type=' + item.value">{{ item.label }}</el-menu-item>
                                </el-submenu>
                                <el-submenu index="3">
                                    <template slot="title">频道</template>
                                    <el-menu-item index="service">专业服务交流</el-menu-item>
                                    <el-menu-item index="resourceShare">资源共享</el-menu-item>
                                </el-submenu>
                                <el-submenu index="4">
                                    <template slot="title">获取服务项目</template>
                                    <!-- <el-menu-item index="designer">专业团队</el-menu-item> -->
                                    <el-menu-item index="selectedProjects">精选项目</el-menu-item>
                                    <el-menu-item index="successProjects">成功案例</el-menu-item>
                                </el-submenu>
                            </el-menu>
                        </div>
                    </div>
                </div>
                <div class="h_r">
                    <div class="r_box" style="display: flex;align-items: center;">
                       
                        <i v-if="isLogin == 0" class="fainro fr-zhanghaoguanli" @click="goLogin"></i>
                        <div v-if="isLogin == 1" style="display: flex;align-items: center;">
                            <el-avatar :size="40" :src="avatarUrl" style="margin-left: 10px;"></el-avatar>
                            <el-menu class="el-menu-demo" mode="horizontal" 
                                background-color="transparent" text-color="#fff" style="border: none;" router>

                                <el-submenu index="">
                                    <template slot="title">{{ userName }}</template>
                                    <el-menu-item index="myIndex">
                                        <i class="fainro fr-gerenziliao"
                                            style="margin-right: 5px;color: #fff;font-size: 18px;"></i>
                                        <span>个人资料</span>
                                    </el-menu-item>
                                    <el-menu-item index="myChangePassword">
                                        <i class="fainro fr-xiugaimima"
                                            style="margin-right: 5px;color: #fff;font-size: 18px;"></i>
                                        <span>修改密码</span>
                                    </el-menu-item>
                                    <el-menu-item index="projectList">
                                        <i class="fainro fr-fabu1"
                                            style="margin-right: 5px;color: #fff;font-size: 18px;"></i>
                                        <span>我的项目</span>
                                    </el-menu-item>
                                    <el-menu-item index="MyProjectList">
                                        <i class="fainro fr-shenqingyaoqiu"
                                            style="margin-right: 5px;color: #fff;font-size: 18px;"></i>
                                        <span>我的案例</span>
                                    </el-menu-item>
                                    <el-menu-item index="myProductManual">
                                        <i class="fainro fr-caidan"
                                            style="margin-right: 5px;color: #fff;font-size: 18px;"></i>
                                        <span>产品手册</span>
                                    </el-menu-item>
                                    <el-menu-item index="mySystemMessages">
                                        <i class="fainro fr-xiaoxi"
                                            style="margin-right: 5px;color: #fff;font-size: 18px;"></i>
                                        <span>系统消息</span>
                                    </el-menu-item>
                                    <el-menu-item index="myMessage">
                                        <i class="fainro fr-liaotian"
                                            style="margin-right: 5px;color: #fff;font-size: 18px;"></i>
                                        <span>我的消息</span>
                                    </el-menu-item>
                                    <el-menu-item index="myCollection">
                                        <i class="fainro fr-shoucang1"
                                            style="margin-right: 5px;color: #fff;font-size: 18px;"></i>
                                        <span>我的收藏</span>
                                    </el-menu-item>
                                    <el-menu-item>
                                        <i class="fainro fr-tuichu1"
                                            style="margin-right: 5px;color: #fff;font-size: 18px;"></i>
                                        <span @click="logout">退出登录</span>
                                    </el-menu-item>
                                </el-submenu>
                            </el-menu>
                        </div>
                    </div>
                </div>
            </div>
        </el-header>
    </div>
</template>

<script>
import avatarUrl from '@/assets/images/tx.png'
import bdLogo from '@/assets/images/logo1.png'

import { getSimple,getInfoByKeys } from '@/api/api'

export default {
    data() {
        return {
            isLogin: 0,
            activeIndex: '1',
            avatarUrl: '',
            userName: '',
            ispg: '',
            newList: [],
            logo:'',
            bdLogo,
        };
    },
    created() {
        this.doGetSimple()
        this.doGetInfoByKeys()
        this.ispg = this.$route.path.substring(1, 3)
        this.isLogin = this.$cookie.get('token') ? 1 : 0
        this.avatarUrl = this.$cookie.get('avatar') ? this.$cookie.get('avatar') : avatarUrl
        this.userName = this.$cookie.get('userName') ? this.$cookie.get('userName') : 'myName'
    },
    methods: {
        goLogin() {
            this.$router.push('/login').catch(err => err)
        },
        logout() {
            if (this.ispg == 'my') {
                this.$router.push('/login').catch(err => err)
            }
            this.$cookie.set('token',null,-1)
            this.$cookie.set('uId', null, -1)
            this.isLogin = 0
        },

        //获取字典
        doGetSimple() {
            getSimple().then(res => {
                if (res) {
                    for (let i = 0; i < res.data.length; i++) {
                        if (res.data[i].type == 'news_kind') {
                            this.newList = res.data[i].sons
                        }

                    }
                }
            }).catch(err => { console.log('err ' + err) })
        },
        //获取系统设置
        doGetInfoByKeys() {
            getInfoByKeys().then(res => {
                if (res) {
                    for (let i = 0; i < res.data.length; i++) {
                        if (res.data[i].sysKey == 'logo') {
                            this.logo = res.data[i].sysValue
                        }
                        
                    }
                }
            }).catch(err => { console.log('err ' + err) })
        },

       
    }

}
</script>

<style lang="less" scoped>
/deep/.el-menu-demo {
    /deep/.is-active {
        border: none;
        color: #fff;
    }
}
/deep/.el-menu {
    .el-menu-item {
        background-color: rgba(0, 0, 0, 0) !important;
    }

    .el-submenu__title {
        background-color: rgba(0, 0, 0, 0) !important;

        i {
            color: #fff !important;
        }
    }
}
.header {
    width: 100%;
    padding: 10px 0;
    background-color: transparent;

    .tContent {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .h_l {
            display: flex;
            align-items: center;
            .h_logo {
                width: 150px;
                height: 36px;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .h_r {
            display: flex;
            align-items: center;

            .r_box {
                display: flex;
                align-items: center;

                i {
                    padding: 0 5px;
                    color: #ffffff;
                    font-size: 35px;
                    cursor: pointer;
                }

                div {
                    display: flex;
                    align-items: center;

                    /deep/ .el-submenu {
                        .el-menu-item {
                            i {
                                font-size: 24px !important;

                            }
                        }
                    }
                }
            }



        }



    }
}
</style>